import React from 'react';

import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import ListIcon from '@mui/icons-material/List';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import WaterfallChartIcon from '@mui/icons-material/WaterfallChart';

export default [
  {
    name: 'Recommendations',
    link: '/mailing-list-recommendations',
    icon: <DynamicFeedIcon />
  },
  {
    name: 'Variations Searched',
    link: '/variations-searched',
    icon: <ScreenSearchDesktopIcon />
  },
  {
    name: 'Users',
    link: '/users',
    icon: <AccountCircleIcon />
  },
  {
    name: 'Deal Lists Admin',
    link: '/deal-lists',
    icon: <ListIcon />
  },
  {
    name: 'Stats',
    link: '/stats',
    icon: <WaterfallChartIcon />
  }
];
